import React, { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

export const AreasContext = React.createContext();

export default class AreasProvider extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      areas: {},
      getElemByAreaKey: this.getElemByAreaKey,
      setElemByAreaKey: this.setElemByAreaKey
    };
  }

  getElemByAreaKey = key => {
    const result = this.state.areas[key];
    return result;
  };

  setElemByAreaKey = (key, elem) => {
    this.setState(state => {
      let areas = Object.assign({}, state.areas);
      areas[key] = elem;
      return { areas: areas };
    });
  };

  render() {
    return (
      <HeaderProvider>
        <HeaderLinksProvider>
          <AreasContext.Provider value={this.state}>{this.props.children}</AreasContext.Provider>
        </HeaderLinksProvider>
      </HeaderProvider>
    );
  }
}
AreasProvider.propTypes = { children: PropTypes.element.isRequired };

export const HeaderContext = createContext();
export const HeaderProvider = ({ children }) => (
  <HeaderContext.Provider value={useState(null)}>{children}</HeaderContext.Provider>
);
HeaderProvider.propTypes = { children: PropTypes.element.isRequired };
export const useHeader = defaultHeader => {
  const [value, setValue] = useContext(HeaderContext);

  useEffect(() => {
    defaultHeader && setValue(defaultHeader);
    return () => setValue(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, setValue];
};

export const HeaderLinksContext = createContext();
export const HeaderLinksProvider = ({ children }) => (
  <HeaderLinksContext.Provider value={useState(null)}>{children}</HeaderLinksContext.Provider>
);
HeaderLinksContext.propTypes = { children: PropTypes.element.isRequired };
HeaderLinksProvider.propTypes = { children: PropTypes.element.isRequired };

export const useHeaderLinks = defaultHeaderLinks => {
  const [value, setValue] = useContext(HeaderLinksContext);

  useEffect(() => {
    defaultHeaderLinks && setValue(defaultHeaderLinks);
    return () => setValue(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, setValue];
};
